// extracted by mini-css-extract-plugin
export default {"mdrInput":"Input_mdrInput__Ydko0","error":"Input_error__lnaZe"};